import styled from '@emotion/styled';

export const ErrorContainer = styled.h2`
  font-size: 36px;
  text-align: center;
  padding: 100px 16px 50px 16px;
  font-weight: 600;

  .subtitle {
    font-size: 16px;
    font-weight: 300;
    margin-top: 8px;
  }
`;
